import { Box, useDisclosure } from '@chakra-ui/react';
import { CustomCellRendererProps } from '@ag-grid-community/react';
import { Trash2Icon } from 'lucide-react';
import { ActionMenu } from '@/components/action-menu';
import { Icon } from '@chakra-ui/react';
import { Prompt } from '@/components/ui/prompt';
import { useRevalidator } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api';

export const TemplatesActionRenderer = ({ data }: CustomCellRendererProps) => {
    const { open: isPromptModalOpen, onOpen: onPromptModalOpen, onClose: onPromptModalClose } = useDisclosure();

    const { revalidate } = useRevalidator();
    const { mutate: deleteTemplate } = useMutation<unknown, unknown, string>({
        mutationFn: async (id) => {
            return api.template.delete(id);
        },
        onSettled: () => {
            revalidate();
        },
    });

    return (
        <>
            <Box pl="4px">
                <ActionMenu
                    actions={[
                        {
                            id: 'delete',
                            action: onPromptModalOpen,
                            icon: (
                                <Icon boxSize={5} color="red">
                                    <Trash2Icon />
                                </Icon>
                            ),
                            label: 'Delete',
                        },
                    ]}
                />
            </Box>
            {isPromptModalOpen && (
                <Prompt
                    open
                    message="This will permanently delete this template and will be removed from all associated templates. This action cannot be undone. Continue?"
                    onContinue={() => {
                        deleteTemplate(data.id);
                    }}
                    onCancel={() => onPromptModalClose()}
                />
            )}
        </>
    );
};
